<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{$t('MESSAGES.Scan qr code')}}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ScanQr :imageLink="data.qr_code" />
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import ScanQr from "@/components/ScanQr.vue";
export default {
  name: "ScanOrders",

  components: {
    ScanQr,
  },

  data() {
    return {
      isWaitingRequest: false,

      data: {
        qr_code: null,
        id: null,
      },
    };
  },

  methods: {
    // start show data
    async showOrder() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `festival-orders/${this.$route.params.id}`,
        });
        this.data.user = res.data.data.FestivalOrder?.id;
        this.data.qr_code = res.data.data.FestivalOrder?.qr_code;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.showOrder();
    // End:: Fire Methods
  },
};
</script>
<style>
.comment {
  border: 1px solid #26a1d6;
  padding: 15px;
  border-radius: 6px;
}
.comment_label {
  color: #26a1d6;
  font-size: 16px;
}
</style>
